<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">统计</a></el-breadcrumb-item>
          <el-breadcrumb-item>会员积分记录</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content-main">
        <el-form :inline="true" size="medium">
          <el-row>
            <el-col :span="3"> <el-input placeholder="单据号" v-model="queryParam.billNumber" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="会员编号" v-model="queryParam.number" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="商家名称" v-model="queryParam.merchantName" size="small" clearable></el-input></el-col>
            <el-col :span="3" style="margin-left:5px"><el-input  placeholder="途径" v-model="queryParam.way" size="small" clearable></el-input></el-col>
            <el-col :span="8" style="margin-left:5px">
              <el-date-picker
                v-model="queryParam.date"
                size="small" 
                type="daterange"
                align="right"
                value-format="yyyy-MM-dd"
                start-placeholder="开始日期"                
                end-placeholder="结束日期"
                @change="dateSelect"
                >
              </el-date-picker>
            </el-col>
            <el-col :span="2" style="margin-left:5px"><el-button type="primary" v-on:click="Search" size="small" >查询</el-button></el-col>
          </el-row>
        </el-form>
        <el-table :data="items" style="width: 100%">
          <el-table-column  prop="BillNumber" :show-overflow-tooltip="true" fixed="left" label="单据号"> </el-table-column>
          <el-table-column  prop="MemberName" label="会员名称"> </el-table-column>
          <el-table-column  prop="number" label="会员编号"> </el-table-column>
          <el-table-column  prop="Mobile"  width="110px" label="手机号"> </el-table-column>
          <el-table-column  prop="MerchantName" label="商家名称"> </el-table-column>
          <el-table-column  prop="Point"  label="积分"> </el-table-column>
          <el-table-column  prop="Balance"  label="操作后余额"> </el-table-column>
          <el-table-column  prop="Type"  label="类型"  > 
            <template slot-scope="scope">
              <span v-if="scope.row.Type == 0">增加</span>
              <span v-if="scope.row.Type == 1">扣除</span>
            </template>
          </el-table-column>
          <el-table-column  prop="Way"  label="途径"></el-table-column>
          <el-table-column  prop="OperateTime"  width="120px" label="操作时间" :formatter="dateFormat"> </el-table-column>
        </el-table>
        <el-pagination
          :hide-on-single-page="true"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParam.pageIndex"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryParam.pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="queryParam.totalCount">
        </el-pagination>
      </div>   
    </section>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {
    props:{
    },
    data (){
      return {        
        items:[],
        queryParam: {
          pageIndex: 1,
          pageSize: 10,
          sort: ' OperateTime desc ',
          totalCount:10,
          billNumber:'',
          number:'',
          merchantName:'',
          way:'',
          beginTime:'',
          endTime:'',
          date:''
        }
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/MemberPointNote',
          params: that.queryParam
        }).then(function (resp) {
          that.queryParam.totalCount = resp.data.totalCount
          that.items = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      dateFormat:function(row, column, cellValue, index){
        let data = row[column.property]
	      return  /\d{4}-\d{1,2}-\d{1,2}/g.exec(data )
      },
      handleSizeChange(val) {
        this.queryParam.pagesize = val 
        this.queryParam.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.queryParam.pageIndex = val 
        this.GetData()
      },
      dateSelect(picker){
        if(picker==null){
          this.queryParam.beginTime = ''
          this.queryParam.endTime = ''
        }else{
          this.queryParam.beginTime = picker[0]
          this.queryParam.endTime = picker[1]
        }
      }
    },
    components:{    
       
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px    

</style>